"use client";

import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { getFriendlyErrorMessage } from "@/lib/error-messages";

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// Next.js App Router route-segment error boundary. Catches errors thrown
// while rendering a page/layout and shows a friendly message instead of a
// stack trace or the error's digest/code.
export default function ErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-muted/40 px-4 text-center">
      <h1 className="text-3xl font-bold text-foreground">Something went wrong</h1>
      <p className="max-w-md text-muted-foreground">
        {getFriendlyErrorMessage(error, "We hit a snag loading this page. Please try again.")}
      </p>
      <Button onClick={() => reset()}>Try again</Button>
    </div>
  );
}
